import { useCallback, useState } from "react";
import downloadChunkedCsv from "../utils/downloadChunkedCsv";
import { useToastError } from "../components/FormError";

/**
 * Wraps `downloadChunkedCsv` with the state and blob-download wiring callers
 * would otherwise duplicate. `reset` is for unmount / dialog-close paths.
 */
export default function useChunkedCsvDownload() {
  const [isDownloading, setIsDownloading] = useState(false);
  const [progress, setProgress] = useState(null);
  const toastError = useToastError();

  const reset = useCallback(() => {
    setIsDownloading(false);
    setProgress(null);
  }, []);

  const download = useCallback(
    async ({ requestChunk, filename }) => {
      setIsDownloading(true);
      setProgress(null);

      try {
        const blob = await downloadChunkedCsv({
          requestChunk,
          onProgress: setProgress
        });

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch {
        toastError("Failed to download CSV. Please try again.");
      } finally {
        setIsDownloading(false);
      }
    },
    [toastError]
  );

  return { download, isDownloading, progress, reset };
}
